class LogoutController {
  constructor($state, $scope, $rootScope, $location, $http, $cookieStore) {

    this.name = 'Logout';
    this.form = 'Logout';

    $http.get(WEBSERVICEURL + '/dataagility/api/service.function/init')
      .then(function successCallback(response) {
        $scope.vm.logOutAppFunction = response.data.find(x => x.code === 'LOGOUT');
        if ($scope.vm.logOutAppFunction && $scope.vm.logOutAppFunction.valueString) {
          $scope.vm.loginURL = $scope.vm.logOutAppFunction.valueString;
        } else {
          $scope.vm.loginURL = window.location.hostname + '/v2/login';
        }
      });
    localStorage.clear();
    $cookieStore.remove('globals');
    $cookieStore.remove('globals');
    $cookieStore.remove('globals');
    $cookieStore.remove('io');
  }
}

export default LogoutController;



// WEBPACK FOOTER //
// ./client/app/components/logout/logout.controller.js